.loadingContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60vh;
    padding: 0 20px;
  }
  
  .loadingSpinner {
    width: 40px;
    height: 40px;
    border: 3px solid var(--bg-tertiary);
    border-top-color: var(--primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .errorContainer {
    max-width: 600px;
    margin: 40px auto;
    padding: 30px;
    text-align: center;
    background-color: var(--bg-secondary);
    border-radius: var(--radius-lg);
    border: 1px solid var(--danger);
  }
  
  .errorContainer h2 {
    color: var(--danger);
    margin-top: 0;
  }
  
  .errorContainer p {
    color: var(--text-secondary);
    margin-bottom: 20px;
  }
  
  .returnButton {
    background-color: var(--primary);
    color: var(--bg-primary);
    border: none;
    padding: 10px 16px;
    border-radius: var(--radius);
    font-size: 16px;
    cursor: pointer;
    margin-top: 16px;
  }
  
  .checkoutHeader {
    background-color: var(--primary);
    color: var(--bg-primary);
    padding: 24px;
    text-align: center;
    margin-bottom: 20px;
  }
  
  .checkoutHeader h2 {
    margin: 0;
    font-size: 24px;
  }
  
  .orderSummaryCard {
    background-color: var(--bg-secondary);
    border-radius: var(--radius-lg);
    padding: 24px;
    margin-bottom: 20px;
    border: 1px solid var(--gray-700);
  }
  
  .orderSummaryCard h3 {
    margin-top: 0;
    margin-bottom: 16px;
    color: var(--text-primary);
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid var(--gray-700);
    padding-bottom: 12px;
  }
  
  .restaurantInfo {
    margin-bottom: 20px;
    color: var(--text-secondary);
  }
  
  .orderItems {
    margin: 20px 0;
  }
  
  .itemsList {
    list-style-type: none;
    padding: 0;
    margin: 10px 0 0 0;
    background-color: var(--bg-tertiary);
    border-radius: var(--radius);
    overflow: hidden;
  }
  
  .orderItem {
    padding: 12px 16px;
    border-bottom: 1px solid var(--gray-700);
  }
  
  .orderItem:last-child {
    border-bottom: none;
  }
  
  .itemDetails {
    display: flex;
    justify-content: space-between;
    color: var(--text-primary);
  }
  
  .itemQuantity {
    font-weight: 500;
    color: var(--text-secondary);
    margin-right: 8px;
  }
  
  .itemName {
    flex: 1;
  }
  
  .itemPrice {
    color: var(--text-secondary);
  }
  
  .orderTotal {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 2px solid var(--gray-700);
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
    color: var(--text-primary);
  }
  
  .paymentSection {
    background-color: var(--bg-secondary);
    border-radius: var(--radius-lg);
    padding: 24px;
    margin-bottom: 20px;
    border: 1px solid var(--gray-700);
  }
  
  .paymentSection h3 {
    margin-top: 0;
    margin-bottom: 16px;
    color: var(--text-primary);
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid var(--gray-700);
    padding-bottom: 12px;
  }
  
  .checkoutForm {
    max-width: 500px;
    margin: 0 auto;
  }
  
  .formGroup {
    margin-bottom: 20px;
  }
  
  .cardLabel {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: var(--text-primary);
  }
  
  .cardElementContainer {
    padding: 12px;
    border: 1px solid var(--gray-700);
    border-radius: var(--radius);
    background-color: var(--bg-tertiary);
  }
  
  .errorMessage {
    color: var(--danger);
    background-color: rgba(244, 67, 54, 0.1);
    padding: 12px;
    border-radius: var(--radius);
    margin-bottom: 16px;
    font-size: 14px;
    border-left: 3px solid var(--danger);
  }
  
  .successMessage {
    text-align: center;
    color: var(--success);
    background-color: rgba(76, 175, 80, 0.1);
    padding: 16px;
    border-radius: var(--radius);
    margin-bottom: 16px;
    border: 1px solid var(--success);
  }
  
  .successMessage h3 {
    margin: 0 0 8px 0;
    color: var(--success);
  }
  
  .successMessage p {
    margin: 0;
    color: var(--text-secondary);
  }
  
  .payButton {
    background-color: var(--primary);
    color: var(--bg-primary);
    border: none;
    padding: 14px 20px;
    border-radius: var(--radius);
    font-size: 16px;
    font-weight: 500;
    width: 100%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
  }
  
  .payButton:hover {
    background-color: var(--primary-dark);
    transform: translateY(-2px);
  }
  
  .payButton:disabled {
    background-color: var(--gray-600);
    color: var(--text-tertiary);
    cursor: not-allowed;
    transform: none;
  }
  
  .spinner {
    animation: spin 1s linear infinite;
    width: 20px;
    height: 20px;
  }